module.exports = __webpack_public_path__ + "1e5a8675217f685a878f214c9be1ec76.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/will-klein.jpg
// module id = 680
// module chunks = 0